import React from 'react';
import { Box, Typography } from '@mui/material';

/**
 * Mobile-friendly summary card: label + prominent value + optional icon.
 * Use above tabs/actions on teacher pages (Question Bank, Students, Manage Tests)
 * for consistent mobile design pattern.
 */
const SummaryCard = ({ label, value, icon: Icon, sx = {} }) => {
  return (
    <Box
      sx={{
        background: (theme) =>
          theme.palette.mode === 'light'
            ? 'linear-gradient(135deg, #1976d2 0%, #1565c0 100%)'
            : 'linear-gradient(135deg, #1e88e5 0%, #1565c0 100%)',
        color: 'white',
        borderRadius: 2,
        p: 2,
        mb: 2,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        minHeight: 72,
        boxShadow: 2,
        ...sx,
      }}
    >
      <Box sx={{ minWidth: 0 }}>
        <Typography variant="body2" sx={{ opacity: 0.95, fontWeight: 500 }}>
          {label}
        </Typography>
        <Typography variant="h4" component="div" sx={{ fontWeight: 700, lineHeight: 1.2, mt: 0.5 }}>
          {value}
        </Typography>
      </Box>
      {Icon && (
        <Box sx={{ ml: 2, flexShrink: 0, opacity: 0.9 }}>
          <Icon sx={{ fontSize: 40 }} />
        </Box>
      )}
    </Box>
  );
};

export default SummaryCard;
